// ----- Setup ----- //
const DOMAINS = {
    DEV: 'thegulocal.com',
    CODE: 'code.dev-theguardian.com',
    PROD: 'theguardian.com',
};
// ----- Functions ----- //
const getQueryParameter = (paramName, defaultValue = '') => {
    const params = new URL(window.location.href).searchParams;
    return (params.get(paramName) ??
        params.get(paramName.toLowerCase()) ??
        params.get(paramName.toUpperCase()) ??
        defaultValue);
};
// Drop leading '?'
// Turn into array of 'param=value'
// Turn each param into array of '[param, value]'
// Filter out items that are not key-value pairs
const getAllQueryParams = () => window.location.search
    .slice(1)
    .split('&')
    .map((a) => a.split('='))
    // Asserting the return type because this filter means this will *always* return an array of arrays of two strings
    .filter((a) => a.length === 2 && a.every((e) => e !== ''));
const getAllQueryParamsWithExclusions = (excluded) => getAllQueryParams().filter((p) => !excluded.includes(p[0] ?? ''));
// Takes a mapping of query params and adds to an absolute or relative URL.
function addQueryParamsToURL(urlString, params) {
    const [baseUrl, ...oldParams] = urlString.split('?');
    const searchParams = new URLSearchParams(oldParams.join('&'));
    Object.keys(params).forEach((key) => params[key] && searchParams.set(key, params[key]));
    return `${baseUrl}?${searchParams.toString()}`;
}
function getOrigin() {
    const loc = window.location;
    return (window.location.origin ||
        `${loc.protocol}//${loc.hostname}${loc.port ? `:${loc.port}` : ''}`);
}
// Retrieves the domain for the given env, e.g. guardian.com/gulocal.com.
function getBaseDomain() {
    const origin = getOrigin();
    if (origin.includes(DOMAINS.DEV)) {
        return DOMAINS.DEV;
    }
    else if (origin.includes(DOMAINS.CODE)) {
        return DOMAINS.CODE;
    }
    return DOMAINS.PROD;
}
function isProd() {
    return getBaseDomain() === 'theguardian.com';
}
function isCode() {
    return getBaseDomain() === 'code.dev-theguardian.com';
}
function isCodeOrProd() {
    return window.location.hostname.includes('theguardian.com');
}
// ----- Exports ----- //
export { getQueryParameter, getAllQueryParams, getAllQueryParamsWithExclusions, getOrigin, getBaseDomain, addQueryParamsToURL, isProd, isCode, isCodeOrProd, };
